<template>
  <div>
    <Header></Header>
    <div class="container">
      <div class="nav"><a href="/login">登录</a> > <span>忘记密码</span></div>
      <div class="form-container">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="密码" prop="pass">
            <el-input
              type="password"
              placeholder="新密码：6～16位字符，区分大小写"
              v-model="ruleForm.pass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="pass2">
            <el-input
              type="password"
              placeholder="请输入确认密码"
              v-model="ruleForm.pass2"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机" prop="phone">
            <label>{{ showphone }}</label>
          </el-form-item>
          <el-form-item label="验证" prop="randCode">
            <el-input
              placeholder="请输入验证码"
              v-model="ruleForm.randcode"
              class="input-with-select"
            >
              <template #append>
                <el-button @click="getCode()">{{ codemsg }}</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="ex-btn"
              @click="submitForm('ruleForm')"
              >确认修改</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<style scoped>
.container {
  width: 980px;
  margin: 0 auto;
  margin-top: 16px;
}
.nav {
  margin-bottom: 16px;
}
.form-container {
  width: 480px;
  margin: 0 auto;
}
a {
  font-size: 13px;
  font-weight: bold;
}
.ex-btn {
  width: 100%;
}
</style>
<script>
import Header from "./headernew.vue";
export default {
  components: {
    Header,
  },
  mounted() {
    var strphone = this.$route.params.phone;
    this.ruleForm.phone = strphone;
    this.showphone = strphone.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2");
  },
  data() {
    var validateRandcode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      callback();
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.pass2 !== "") {
          this.$refs.ruleForm.validateField("pass2");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass2) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: { pass: "", pass2: "", phone: "", randcode: "" },
      showphone: "",
      smsSending: false,
      codemsg: "获取验证码",
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        pass2: [{ validator: validatePass2, trigger: "blur" }],
        phone: [{ validator: validatePhone, trigger: "blur" }],
        randcode: [{ validator: validateRandcode, trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let verimodel = {
            code: this.ruleForm.randcode,
            phone: this.ruleForm.phone,
          };
          this.$http.post("/api/VerifyCode", verimodel).then((res) => {
            if (res.data.code == 200) {
              this.$http.post("/api/password", this.ruleForm).then((res) => {
                console.log(res);
                if (res.data == 200) {
                  this.$router.push({ name: "psetsucc" });
                } else {
                  this.open("重置密码失败，请重试");
                }
              });
            } else {
              this.ruleForm.randcode = "";
              this.open("验证码错误，请重新获取");
            }
          });
        }
      });
    },
    open(msg) {
      this.$alert(msg, "提醒", {
        confirmButtonText: "确定",
      });
    },
    getCode() {
      if (this.smsSending) return false;
      this.smsSending = true;
      this.codemsg = "60s获取验证码";
      let i = 59;
      var timer = setInterval(() => {
        this.codemsg = i-- + "s获取验证码";
        if (i <= 0) {
          clearInterval(timer);
          this.codemsg = "获取验证码";
          this.smsSending = false;
        }
      }, 1000);

      //获取验证码
      this.$http
        .get("/api/VerifyCode?type=1&phone=" + this.ruleForm.phone)
        .then((r) => {
          if (r.data.code != 200) {
            clearInterval(timer);
            this.open(r.data.msg);
            this.codemsg = "获取验证码";
            this.smsSending = false;
          } else {
            this.ruleForm.randcode = r.data.msg;
          }
        }) //接口调用成功返回的数据
        .catch((err) => console.log(err)); //接口调用失败返回的数据
    },
  },
};
</script>

